export function SentenceList(list: string[]) {
    if(!list) {
        return list;
    }
    if(list.length < 3) {
        return list.join(" and ")
    }
    else return list.map((s,i) => i === list.length - 1 ? `and ${s}` : s).join(", ")
}